export const TOGGLE_MENU = 'toggle_menu';
export const CLOSE_MENU = 'CLOSE_MENU';
